import { ConversationObject } from '@lyrahealth-inc/shared-app-logic/src/models/conversation/Conversation'

export const getAnchorId = (conversation: ConversationObject): string =>
  conversation.anchor_patient_lyra_id ?? conversation.patient_lyra_id
